//http://www.vrtranspoint.fi/fi/vr-transpoint/linked/

//=require modules/branch-bar.js
//=require modules/mustache.js
//=require vendor/jquery-1.9.1.min.js
//=require vendor/bxslider.min.js

(function($, Mustache) {
  var ajaxReq = null;
  var template = null;

  function getTemplate() {
    var template = $('#linked-article-template').html();
    Mustache.parse(template); // speed up future uses

    return template;
  }

  function loadMoreLinkedArticles(that) {
    var $elem = $(that);
    var url = $elem.data('url');
    var articlesPerLoad = $elem.data('articles-per-load');
    var offset = $elem.data('offset') || 0;
    var category = $elem.data('category');
    var liftOrdering = $elem.data('lift-ordering') || false;
    var search = $elem.data('search') || null;

    template = template ? template : getTemplate();

    if(ajaxReq) {
      ajaxReq.abort();
    }

    ajaxReq = $.ajax({
      method: 'GET',
      url: url,
      data: {
        category : category,
        articlesPerLoad : articlesPerLoad ? parseInt(articlesPerLoad) : null,
        offset: offset ? parseInt(offset) : 0,
        liftOrdering: liftOrdering,
        search: search
      }
    }).done(function(data) {
      if(data.articles) {
        var rendered = Mustache.render(template, { articles: data.articles });
        $elem.parent().siblings('.linked-articles-list').last().append(rendered);
      }

      if(data.hasMore) {
        // Update offset based on article count
        $elem.data('offset', offset + data.articles.length);
      } else {
        $elem.fadeOut();
      }
    });
  }

  $(document).ready(function() {
    $('.js-load-more-linked-articles').on('click', function(e) {
      loadMoreLinkedArticles(this);
    });

    $('.js-linked-nav-toggle').on('click', function(e) {
      $(this).siblings().toggleClass('active');
    });

    var $sliders = $('.linked-hero-slider ul');
    $.each($sliders, function(i, slider) {
      var $slider = $(slider);

      $slider.bxSlider({
        auto: false,
        pager: false,
        autoControls: false,
        controls: false,
        speed: 1000
      });

      var $parent = $slider.closest('.linked-hero-slider')
      $parent.find('.slider-prev').on('click', function(e) {
        $slider.goToPrevSlide();
      });

      $parent.find('.slider-next').on('click', function(e) {
        $slider.goToNextSlide();
      });
    });

  });

})(jQuery, Mustache);
